var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loaderWrapper"}},[_c('img',{staticClass:"animatedLogo",attrs:{"src":_vm.logo}}),_c('h1',{staticClass:"schemeTitle"},[_vm._v(" Loading managers.. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }